<template>
    <div style="overflow-x:hidden">
        <BannerStatic :ban="banner" style="height: 600px;"></BannerStatic>
        
        <School :bg="background" class="px-360"></School>
    </div>
</template>

<script>
import BannerStatic from '@/components/header/bannerStatic.vue'
import School from '@/components/school/school.vue'

export default {
    components:{
        BannerStatic,
        School
    },
    data(){
        return{
            banner: require('@/assets/employ/new-3.1.jpg'),
            background: require('@/assets/bgHonor.png')
        }
    }
    
}
</script>